export default {
  props: {
    form: Object
  },
  model: {
    prop: 'form',
    method: 'next'
  },
  methods: {
    validate () {
      if (!this.$v2) {
        this.$emit('next')
        return
      }

      if (this.$v2.forceValidateForm()) {
        for (const key in this.$v2.blurredFields) {
          this.$v2.blurredFields[key] = false
        }

        this.$emit('next')
      }
    }
  }
}
